import { useLayoutEffect } from 'react'
import { observer } from 'mobx-react'
import rootStore from '@/app/store'
import { useDialogRef } from '@/utils/dialog'
import TermsOfServiceDialog from './TermsOfServiceDialog'

const TermsOfServiceManager = observer(() => {
  const { auth } = rootStore
  const { dialogRef: tosDialogRef, handleOpen: openTosDialog } = useDialogRef()

  // Check if the user needs to review and accept the TOS
  useLayoutEffect(() => {
    const hasSkipTosFormCookie = document.cookie.includes('skiptosform=true')

    if (hasSkipTosFormCookie) {
      return
    }

    if (auth.user && auth.currentTOS && auth.requiresTOSReview) {
      openTosDialog()
    }
  }, [auth.user, auth.currentTOS, auth.requiresTOSReview])

  // Handle accepting the TOS
  const handleAcceptTOS = async () => {
    return await auth.acceptTOS()
  }

  // Handle declining the TOS (user chooses to logout)
  const handleDeclineTOS = () => {
    auth.logout()
  }

  // Don't render anything if no TOS review is required
  if (!auth.user || !auth.currentTOS || !auth.requiresTOSReview) {
    return null
  }

  return (
    <TermsOfServiceDialog
      dialogRef={tosDialogRef}
      tosDocument={auth.currentTOS}
      onAccept={handleAcceptTOS}
      onDecline={handleDeclineTOS}
    />
  )
})

export default TermsOfServiceManager
